<template>
  <div id="illus">
    <h2>ILLUSTRATIONS</h2>
    <!-- <Titulos :titu="'ILLUSTRATIONS'"></Titulos> -->
    <p class="baja">Some of the drawings I made for media companies.</p>
    <ul id="ulIllus">
      <li v-for="illus in dataIllus" :key="illus.id" class="stepLi">
          <!-- <a class="linkLi" :href="illus.link" target="_blank"> -->
          <a class="linkLi" href="" @click.prevent="cambiarId(illus.id)" target="_blank">
            <div class="conteLi">
              <div class="contImg">
                <video v-if="illus.video" autoplay loop muted>
                  <source :src="require(`@/assets/img/vid/`+ illus.imagen)" type="video/mp4">
                  <!-- <source :src="require(`@/assets/img/vid/`+ illus.imagen)" type="video/ogg"> -->
                  Your browser does not support the video tag.</video>
                <img v-else :src="require(`@/assets/img/illus/`+ illus.imagen)" :alt="illus.imagen">
              </div>
              <div class="contText">
                <h3 class="titu">{{ illus.titulo }}</h3>
                <!-- <p class="baja">{{ illus.bajada }}</p> -->
                <!-- <p class="secc">{{ illus.seccion }}</p> -->
                <!-- <div  class="base"> -->
                  <a v-if="illus.link !== 'no'" class="link" :href="illus.link" target="_blank"></a>
                <!-- </div> -->
              </div>
            </div>
          </a>
      </li>
    </ul>
  </div>
</template>

<script>
// import Titulos from './Titulos.vue'

export default {
    components: {
        // Titulos
    },
    //  data(){
    //   return {
    //     esteId: null,
    //   }
    // },
    props: {
        dataIllus: {
            type: Array,
            default: () => []
        },
    },
    methods: {
      cambiarId(id){
        // console.log('Illus ID', id);
        // this.abre = true
        // this.esteId = id
        this.$emit('abrirDetalles', true)
        this.$emit('cambiaID', id)
      },
    }
}
</script>

<style lang="scss">
#illus{
    width: 100%;
    padding-top: 40px;
    margin: 250px auto 130px;

    h2{
      font-family: var(--roboto);
      font-size: 4rem;
      font-weight: 300;
      color: var(--white);
      letter-spacing: 40px;
      padding-top: 70px;
    }
    .baja{
      text-align: center;
      margin: auto;
      font-family: var(--roboto);
      font-size: 1.2rem;
      font-weight: 300;
      color: var(--white);
    }

    ul#ulIllus{
        width: 70%;
        margin: 100px auto;
        list-style: none;
        display: flex;
        justify-content: center;
        flex-flow: row wrap;
        align-items: flex-start;
        align-content: flex-start;
        padding: 0 0 100px;
        gap: 0 4%;
        padding-inline-start: 0px;
    
        li.stepLi{
            width: 47%;
            display: flex;
            justify-content: center;
            flex-flow: column nowrap;
            align-items: center;
            align-content: center;
            padding: 50px 10px 0;
            border-bottom: .5px solid var(--white);
            cursor: pointer;
            transition: all .3s ease;

            &:hover{ // hover de .stepLi
              background-color: rgba(0,0,0,.7);
              .contText{
                .link{
                  &:after{
                    animation: .5s armeX 1 linear;
                  }
                  &:before{
                    animation: .5s armeY 1 linear;
                  }
                }
              }
            }

            .linkLi{
              text-decoration: none;
            }

            .conteLi{
                width: 100%;
                display: flex;
                justify-content: center;
                flex-flow: column nowrap;
                align-items: center;
                align-content: center;
                color: var(--white);
                cursor: pointer;

                .contImg{
                    align-self: center;
                    width: 95%;
                    cursor: pointer;
                    
                    img, video{
                        width: 100%;
                    }
                }
                .contText{
                    width: 95%;
                    min-height: 60px;
                    display: flex;
                    justify-content: flex-start;
                    flex-flow: row wrap;
                    align-items: flex-start;
                    align-content: flex-start;
                    cursor: pointer;
    
                    .titu{
                        font-size: 1.2rem;
                        font-weight: 300;
                        text-transform: uppercase;
                        width: 80%;
                        margin: 10px 0;
                        text-align: left;
                        flex-grow: 2;
                    }
    
                    .link{
                      width: 40px;
                      height: 40px;
                      position: relative;
                      margin: auto;
                      z-index: 10;
                      cursor: pointer;

                      &:after {
                        content: "";
                        width: 27px;
                        height: 2px;
                        background: var(--white);
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateX(-50%);
                      }
                      &:before {
                        content: "";
                        width: 2px;
                        height: 27px;
                        background: var(--white);
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateY(-50%);
                      }
                    }
                    .divSkills{
                        margin: auto;
                        width: 90%;
                        text-align: left;

                        img{
                          width: 45px;
                          margin: auto;
                        }
                    }
                }
            }

            
            
        }
    }
    @keyframes armeY {
      0% {
        transform: translateY(-50%);
        opacity: 1;
      }
      10% {
        transform: translateY(100%);
        opacity: 0;
      }
      50% {
        transform: translateY(-100%);
        opacity: 0;
      }
      75% {
        transform: translateY(-100%);
        opacity: 0;
      }
      100% {
        transform: translateY(-50%);
        opacity: 1;
      }
      
    }
    @keyframes armeX {
      0% {
        transform: translateX(-50%);
        opacity: 1;
      }
      10% {
        transform: translateX(100%);
        opacity: 0;
      }
      50% {
        transform: translateX(-100%);
        opacity: 0;
      }
      75% {
        transform: translateX(-100%);
        opacity: 0;
      }
      100% {
        transform: translateX(-50%);
        opacity: 1;
      }
      
    }
}
@media screen and (max-width: 900px){
    #illus{
      margin: 150px auto 130px;
      h2{
        letter-spacing: 20px;
        font-size: 3rem;
      }
      ul#ulIllus{
        width: 85%;
        li.stepLi{
          .conteLi{
            .contText{
              .titu{
                font-size: 1.1rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .link{
                &:after {
                  width: 22px;
                  transform: translateX(-48%);
                }
                &:before {
                  height: 22px;
                  transform: translateY(-48%);
                }
              }
            }
          }
        }
      }
    }
}
@media screen and (max-width: 600px){
  #illus{
    margin: 250px auto 60px;

    h2{
      font-size: 2.5rem;
      letter-spacing: 5px;
      padding-top: 0px;
    }
    .baja{
      width: 90%;
      font-size: 1rem;
    }
    ul#ulIllus{
      width: 90%;
      flex-flow: column nowrap;
      align-content: center;
      margin: 70px auto;

      li.stepLi{
        width: 90%;
        align-self: center;
        min-height: unset;
        margin: 30px auto;
        padding: 10px 0 0;

        .conteLi{
          flex-flow: column nowrap;

          .contImg{
            width: 100%;
          }
          .contText{
            width: 100%;
            flex-flow: row-reverse;

            .titu{
              width: 95%;
              font-size: 1.2rem;
            }
            .link{
              margin: 2px auto 10px;
              margin-right: 10px;
            }
            .divSkills{
              text-align: center;

              img{
                width: 35px;
              }
            }
          }
        }
      }
    }
  }
}
</style>